export enum SubType {
    NUTRITION = "nutrition",
    HEALTH = "health",
    HEALTH_DNA = "health_dna",
    METABOLIC = "metabolic",
    METABOLIC_LITE = "metabolic_lite",
    OLD = "old",
    NONE = "none",
}